import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-body-2 text-medium-emphasis" }
const _hoisted_2 = { class: "text-h5" }
const _hoisted_3 = { class: "text-h5" }
const _hoisted_4 = { class: "text-h5" }
const _hoisted_5 = { class: "text-h5" }
const _hoisted_6 = ["colspan"]
const _hoisted_7 = {
  key: 1,
  class: "pa-4"
}
const _hoisted_8 = {
  key: 2,
  class: "pa-4 text-medium-emphasis"
}

import { computed, onMounted, ref, watch } from "vue";
import { useCveStore } from "../store/cveStore";
import type { CveFinding, RepoDetail } from "../types";


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardView',
  setup(__props) {

const store = useCveStore();
const snackbar = ref(false);
const snackbarText = ref("");
const snackbarColor = ref("success");
const expanded = ref<string[]>([]);
const detailLoading = ref<Record<string, boolean>>({});
const detailCache = ref<Record<string, RepoDetail>>({});

const severityColor: Record<string, string> = {
  CRITICAL: "error",
  HIGH: "warning",
  MEDIUM: "orange",
  LOW: "info",
  NONE: "grey",
};

const headers = [
  { title: "", key: "data-table-expand", sortable: false, width: 48 },
  { title: "Service", key: "serviceName", sortable: true },
  { title: "Language", key: "language", sortable: true },
  { title: "Severity", key: "maxSeverity", sortable: true },
  { title: "CVEs", key: "cveCount", sortable: true },
  { title: "Audit", key: "auditStatus", sortable: true },
  { title: "Last scanned", key: "lastScannedAt", sortable: true },
  { title: "Actions", key: "actions", sortable: false },
];

const findingHeaders = [
  { title: "Advisory", key: "advisoryId" },
  { title: "Package", key: "package" },
  { title: "Version", key: "version" },
  { title: "CVSS", key: "cvss" },
  { title: "Severity", key: "severity" },
  { title: "Ecosystem", key: "ecosystem" },
];

const isJobRunning = computed(() => (serviceName: string) => serviceName in store.activeJobs);

onMounted(async () => {
  await store.loadDashboard(true);
});

watch(expanded, (newExpanded) => {
  for (const serviceName of newExpanded) {
    void handleExpand(serviceName, true);
  }
});

async function handleRefresh(): Promise<void> {
  detailCache.value = {};
  expanded.value = [];
  await store.loadDashboard(true);
}

async function handleExpand(serviceName: string, isExpanded: boolean): Promise<void> {
  if (!isExpanded || detailCache.value[serviceName]) {
    return;
  }
  detailLoading.value[serviceName] = true;
  try {
    detailCache.value[serviceName] = await store.loadRepoDetail(serviceName);
  } catch (err) {
    snackbarText.value = err instanceof Error ? err.message : "Failed to load CVE details";
    snackbarColor.value = "error";
    snackbar.value = true;
  } finally {
    detailLoading.value[serviceName] = false;
  }
}

function formatDate(value: string | null): string {
  if (!value) {
    return "—";
  }
  return new Date(value).toLocaleString();
}

async function handleOpenMr(serviceName: string, existingMrUrl: string | null): Promise<void> {
  if (existingMrUrl) {
    window.open(existingMrUrl, "_blank", "noopener,noreferrer");
    return;
  }
  try {
    const mrUrl = await store.openMr(serviceName);
    if (mrUrl) {
      snackbarText.value = `MR opened for ${serviceName}`;
      snackbarColor.value = "success";
      window.open(mrUrl, "_blank", "noopener,noreferrer");
    } else {
      snackbarText.value = `Remediation queued for ${serviceName}`;
      snackbarColor.value = "info";
    }
  } catch (err) {
    snackbarText.value = err instanceof Error ? err.message : "Failed to open MR";
    snackbarColor.value = "error";
  }
  snackbar.value = true;
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-6"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        align: "center",
        class: "mb-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "8"
          }, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "text-h4 mb-1" }, "Amb CVE Assistant", -1)),
              _createElementVNode("p", _hoisted_1, " OWASP dependency-check across " + _toDisplayString(_unref(store).summary.repos) + " ambulatory repos ", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "4",
            class: "text-md-end"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                color: "primary",
                loading: _unref(store).scanning,
                onClick: handleRefresh
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" Refresh scan ", -1)
                ]))]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "mb-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "6",
            sm: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                variant: "tonal",
                color: "error"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "text-center" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(store).summary.totalCves), 1),
                      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-caption" }, "Total CVEs", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            sm: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                variant: "tonal",
                color: "warning"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "text-center" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(store).summary.failing), 1),
                      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-caption" }, "Audit failed", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            sm: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                variant: "tonal",
                color: "success"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "text-center" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(store).summary.passing), 1),
                      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-caption" }, "Audit passing", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            sm: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { variant: "tonal" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "text-center" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(store).summary.unknown), 1),
                      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-caption" }, "Not scanned", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_unref(store).needsGitLabToken)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 0,
            type: "warning",
            class: "mb-4",
            variant: "tonal"
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode(" GitLab is not configured. Set ", -1),
              _createElementVNode("code", null, "GITLAB_TOKEN", -1),
              _createTextVNode(" in ", -1),
              _createElementVNode("code", null, "amb-cve-assistant/.env", -1),
              _createTextVNode(", or run ", -1),
              _createElementVNode("code", null, "glab auth login --hostname git.getwellnetwork.com", -1),
              _createTextVNode(", then restart the API and click Refresh scan. ", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(store).error)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 1,
            type: "error",
            class: "mb-4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(store).error), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_data_table, {
        expanded: expanded.value,
        "onUpdate:expanded": _cache[0] || (_cache[0] = ($event: any) => ((expanded).value = $event)),
        headers: headers,
        items: _unref(store).rows,
        loading: _unref(store).loading || _unref(store).scanning,
        "item-key": "serviceName",
        "show-expand": "",
        class: "elevation-1"
      }, {
        "item.maxSeverity": _withCtx(({ item }) => [
          _createVNode(_component_v_chip, {
            color: severityColor[item.maxSeverity] || 'grey',
            size: "small",
            label: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.maxSeverity), 1)
            ]),
            _: 2
          }, 1032, ["color"])
        ]),
        "item.auditStatus": _withCtx(({ item }) => [
          _createVNode(_component_v_chip, {
            color: item.auditStatus === 'success' ? 'success' : item.auditStatus === 'failed' ? 'error' : 'grey',
            size: "small",
            variant: "tonal"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.auditStatus), 1)
            ]),
            _: 2
          }, 1032, ["color"])
        ]),
        "item.lastScannedAt": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(formatDate(item.lastScannedAt)), 1)
        ]),
        "item.actions": _withCtx(({ item }) => [
          _createVNode(_component_v_btn, {
            size: "small",
            color: "primary",
            variant: "flat",
            loading: isJobRunning.value(item.serviceName),
            disabled: item.auditStatus === 'success',
            onClick: ($event: any) => (handleOpenMr(item.serviceName, item.mrUrl))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.mrUrl ? "View MR" : "Open MR"), 1)
            ]),
            _: 2
          }, 1032, ["loading", "disabled", "onClick"])
        ]),
        "expanded-row": _withCtx(({ columns, item }) => [
          _createElementVNode("tr", null, [
            _createElementVNode("td", {
              colspan: columns.length
            }, [
              (detailLoading.value[item.serviceName])
                ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                    key: 0,
                    indeterminate: "",
                    class: "mb-2"
                  }))
                : (detailCache.value[item.serviceName]?.findings?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_v_data_table, {
                        headers: findingHeaders,
                        items: detailCache.value[item.serviceName].findings as CveFinding[],
                        density: "compact",
                        "hide-default-footer": ""
                      }, {
                        "item.severity": _withCtx(({ item: finding }) => [
                          _createVNode(_component_v_chip, {
                            color: severityColor[finding.severity] || 'grey',
                            size: "x-small",
                            label: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(finding.severity), 1)
                            ]),
                            _: 2
                          }, 1032, ["color"])
                        ]),
                        _: 1
                      }, 8, ["items"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, " No CVE findings — audit may be passing or not yet scanned. "))
            ], 8, _hoisted_6)
          ])
        ]),
        _: 1
      }, 8, ["expanded", "items", "loading"]),
      _createVNode(_component_v_snackbar, {
        modelValue: snackbar.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((snackbar).value = $event)),
        color: snackbarColor.value,
        timeout: "5000"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(snackbarText.value), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "color"])
    ]),
    _: 1
  }))
}
}

})